<!-- Admin Header with integrated navigation -->
<div class="bg-white border-b border-gray-200">
  <div class="mx-auto px-4 max-w-7xl">
    <!-- Top Section: Title -->
    <div class="pt-5 pb-1">
      <h1 class="text-xl font-semibold text-gray-900">Administration</h1>
      <p class="text-sm text-gray-400 mt-0.5">Manage your workspace settings</p>
    </div>

    <!-- Navigation Tabs -->
    <div class="flex items-center gap-1 -mb-px mt-3">
      @for(item of navConfig().items; track item.id) {
        <button
          (click)="onTabChange(item.id)"
          class="relative px-4 py-3 text-sm font-semibold transition-all duration-200 flex items-center gap-2 rounded-t-lg cursor-pointer"
          [class.text-blue-600]="activeTab() === item.id"
          [class.text-gray-500]="activeTab() !== item.id"
          [class.hover:text-gray-700]="activeTab() !== item.id"
          [class.hover:bg-gray-50]="activeTab() !== item.id">

          <!-- Icon -->
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icon"/>
          </svg>

          <!-- Label -->
          <span>{{ item.label }}</span>

          <!-- Active indicator -->
          @if(activeTab() === item.id) {
            <span class="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full"></span>
          }
        </button>
      }
    </div>
  </div>
</div>

<!-- Content Area -->
<div class="bg-gray-50 min-h-[calc(100vh-180px)]">
  <div class="mx-auto px-4 py-6">
    <router-outlet />
  </div>
</div>
